import React from 'react';
import { MdDelete } from 'react-icons/md';
import {
    ADMIN,
    ASSISTANT_MANAGER,
    MANAGER
} from 'components/RoleGate/constants';
import RoleButton from 'components/RoleButton';
import ButtonIconWrapper from 'components/ButtonIconWrapper';
import { DELETE_SPRAY_EVENT_MODAL } from '../DeleteSprayEventModal';

export default function DeleteSprayEventButton(): React.ReactElement {
    return (
        <RoleButton
            requiredRoles={[ADMIN, MANAGER, ASSISTANT_MANAGER]}
            params={{
                [DELETE_SPRAY_EVENT_MODAL]: true
            }}
            buttonProps={{
                icon: true,
                color: 'black',
                basic: true,
                style: {
                    marginRight: 8,
                    marginLeft: 8
                }
            }}
        >
            <ButtonIconWrapper>
                <MdDelete
                    style={{
                        fontSize: 20
                    }}
                />
            </ButtonIconWrapper>
            Delete
        </RoleButton>
    );
}
